import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Shop from '../component/user/shop/item/Shop'
import Home from '../component/user/home/Home'
import ShopItemDetails from '../component/user/shop/item/ShopItemDetails'
import CartContainer from '../component/user/cart/CartContainer'
import Checkout from '../component/user/checkout/Checkout'
import CheckoutReceipt from '../component/user/checkout/CheckoutReceipt'
import About from '../component/user/about/About'
import Contact from '../component/user/contact/Contact'
import PaymentAndDelivery from '../component/user/terms/PaymentAndDelivery'
import Complaint from '../component/user/terms/Complaint'
import PrivacyProtection from '../component/user/terms/PrivacyProtection'
import CustomerRights from '../component/user/terms/CustomerRights'
import AdminLogin from '../component/admin/login/AdminLogin'
import AdminOrders from '../component/admin/order/AdminOrders'
import AdminItems from '../component/admin/item/AdminItemContainer'
import AdminBlog from '../component/admin/blog/AdminBlogContainer.vue'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                hideFooter: true
            }
        },
        {
            path: '/shop',
            redirect: '/shop/body'
        },
        {
            path: '/shop/:category',
            name: 'shop',
            component: Shop
        },
        {
            path: '/shop/item/:id',
            name: 'item',
            component: ShopItemDetails
        },
        {
            path: '/cart',
            name: 'cart',
            component: CartContainer
        },
        {
            path: '/checkout',
            name: 'checkout',
            component: Checkout
        },
        {
            path: '/checkout/receipt',
            name: 'checkoutReceipt',
            component: CheckoutReceipt
        },
        {
            path: '/about',
            name: 'about',
            component: About
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        },
        {
            path: '/paymentanddelivery',
            name: 'paymentanddelivery',
            component: PaymentAndDelivery
        },
        {
            path: '/complaint',
            name: 'complaint',
            component: Complaint
        },
        {
            path: '/privacyprotection',
            name: 'privacyprotection',
            component: PrivacyProtection
        },
        {
            path: '/customerrights',
            name: 'customerrights',
            component: CustomerRights
        },
        {
            path: '/admin/login',
            name: 'adminLogin',
            component: AdminLogin,
            meta: {
                hideFooter: true
            }
        },
        {
            path: '/admin/',
            name: 'adminOrders',
            component: AdminOrders,
            meta: {
                isAdmin : true,
                requiresAuth: true,
                hideFooter: true
            }
        },
        {
            path: '/admin/items',
            name: 'adminItems',
            component: AdminItems,
            meta: {
                isAdmin: true,
                requiresAuth: true,
                hideFooter: true
            }
        },
        {
            path: '/admin/blog',
            name: 'adminBlog',
            component: AdminBlog,
            meta: {
                isAdmin: true,
                requiresAuth: true,
                hideFooter: true
            }
        }
    ],
    mode: 'history'
})

router.beforeEach((to, from, next) => {
    const loggedInUser = store.getters.getLoggedInUser
    const isAdminRoute = to.matched.some(record => record.meta.requiresAuth && record.meta.isAdmin)
    const isAdminToken = Object.keys(loggedInUser).length > 0 && loggedInUser.role === 'ADMIN'

    if (isAdminRoute) {
        if (isAdminToken) next()
        else next({
            path: '/admin/login',
            params: {nextUrl: to.fullPath}
        })
    } else next()
})

export default router
